module.exports = __webpack_public_path__ + "static/media/loader.73c9a6b4.svg";